export default __webpack_public_path__ + "static/media/icon-video.651a9946.svg";